import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../classes/api';
import { StorageService } from '../../../shared/services/storage.service';

@Injectable()
export class AclResolver implements Resolve<Promise<AclAccess>> {
    constructor(
        private apiService: ApiService,
        private storageService: StorageService
    ) {}

    resolve(route: ActivatedRouteSnapshot) {
        const ressource = route.data.acl;
        const ressourceId = route.paramMap.get('id') || null;

        if (!ressource) {
            throw new Error('Veuillez spécifier une ressource via la clé \'acl\' dans le routing.');
        }

        return this.getAclAccess(ressource, ressourceId);
    }

    getAclAccess(ressource: string, ressourceId?: string) {
        return new Promise<AclAccess>((resolve, reject) => {
            const aclAccess = new AclAccess(this.storageService.getAcl(ressource));

            // Si on spécifie un ressourceId, on peut check les droits en fonction des données de la ressource
            if (ressourceId) {
                this.getIsAllowedActions(ressource, ressourceId)
                .subscribe(retour => {
                    if (retour.status === 200) {
                        for (const action in retour.data) {
                            if (aclAccess[action] !== undefined) {
                                aclAccess[action] = retour.data[action];
                            }
                        }
                    }
                    resolve(aclAccess);
                });
            }
            resolve(aclAccess);
        });
    }

    getIsAllowedActions(ressource: string, ressourceId: string): Observable<ApiResponse> {
        return this.apiService.get('is-allowed-actions/' + ressource + '/' + ressourceId);
    }
}
